// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2atFU","signatureButtonsRight":"ModalSign_signatureButtonsRight__2CpUS"};